import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/components/ui/select";
import { useDashboardContext } from "src/context/DashboardContext";
import { cn } from "src/lib/utils";

interface BranchSelectProps {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	/** Label for the "no filter" option. `"0"` is the sentinel the pages use to clear it. */
	allLabel?: string;
	className?: string;
}

/**
 * Store/warehouse filter, shared by every branch-scoped list (spec §3.1).
 * Options come from the entities already loaded into DashboardContext.
 */
const BranchSelect = ({ value, onChange, placeholder = "All stores", allLabel = "All stores", className }: BranchSelectProps) => {
	const { entities } = useDashboardContext();

	return (
		<Select value={value || "0"} onValueChange={onChange}>
			<SelectTrigger
				className={cn(
					"tw-h-10 tw-w-full tw-rounded-[10px] !tw-border-border tw-bg-white tw-text-[13.5px] tw-text-text sm:tw-w-[200px]",
					className
				)}
			>
				<SelectValue placeholder={placeholder} />
			</SelectTrigger>
			<SelectContent>
				<SelectItem value="0">{allLabel}</SelectItem>
				{entities?.map((entity) => (
					<SelectItem key={entity.uuid} value={entity.uuid}>
						{entity.name}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};

export default BranchSelect;
